module.exports = __webpack_public_path__ + "img/brokerpay1.db48d4d5.png";